import { setSearchParam } from "./searchParams";

export default function setHistoryState(id: string, value: string) {
  const searchParams = setSearchParam(window.location.search, id, value);
  window.history.pushState(null, "", `?${searchParams}`);
}
